<template>
    <div id="personalRecords" class="background-ash pl20 pr20 pb20">
        <!--搜索条件-->
        <div class="search_list background-white">
            <ul class="lists">
                <li>
                    <span>商品名称</span>
                    <el-input size="small" class="width180" @keyup.native.enter="searchGetDataList" v-model="getDataParam.productNameLike" placeholder="请输入商品名称"></el-input>
                </li>
				<li>
                    <span>查询时间</span>
                    <el-date-picker  size="small" v-model="time1" type="daterange"  range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                </li>
				<li>
                    <span>是否收藏</span>
                    <el-select size="small" class="select width100" collapse-tags v-model="getDataParam.isFollow" >
                        <el-option label="全部" value="all"></el-option>
                        <el-option label="是" value="T"></el-option>
                        <el-option label="否" value="F"></el-option>
                    </el-select>
                </li>
            </ul>
			<div class="btns">
                <el-button size="small" type="primary"  @click="searchGetDataList">搜索</el-button>
            </div>
        </div>
        <!--内容-->
        <div class="pt20 content">
            <!-- 表头操作 -->
            <div class="watchBar">
                <div class="btns right">
                    <el-button size="small" class="export-right" type="primary" plain @click="getExport">导出</el-button>
                </div>
            </div>
            <div class="tab">
                <el-table ref="checkList"  size="mini" :data="dataList" tooltip-effect="dark" height="100%">
                    <el-table-column type="index" label="序号"></el-table-column>
                    <el-table-column label="查询时间" prop="gmtQuery"></el-table-column>
                    <el-table-column label="商品ID">
                        <template slot-scope="scope">{{ scope.row.id || '' }}</template>
                    </el-table-column>
                    <el-table-column label="商品名称" prop="name"></el-table-column>
                    <el-table-column label="规格" prop="specifications"></el-table-column>
                    <el-table-column label="厂家" prop="manufactur"></el-table-column>
                    <el-table-column label="批准文号" prop="licenseNumber"></el-table-column>
                    <el-table-column label="平均价" prop="averagePrice"></el-table-column>
                    <el-table-column label="最低价" prop="lowerPrice"></el-table-column>
                    <el-table-column label="计划采购价" prop="planPrice"></el-table-column>
                    <el-table-column label="计划采购量" prop="planQuantity"></el-table-column>
                    <el-table-column label="低价网站">
                        <template slot-scope="scope">
                            <a :href="scope.row.url" target="black">新窗口打开</a>
                        </template>
                    </el-table-column>
                    <el-table-column label="是否收藏">
                        <template slot-scope="scope">
                            {{scope.row.isFollow === 'T' ? '是' : '否'}}
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="page background-white text-right p20">
                <el-pagination @size-change="changePageSize" @current-change="getDataList" :current-page.sync="getDataParam.page"
                :page-sizes="[10, 20, 50, 100]" :page-size="getDataParam.size" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
export default {
	name: 'personalRecords',
	data () {
		return {
			getDataParam: {
                userId: '', //用户id
                geGmtQuery: '', //查询开始时间
                leGmtQuery:'', //查询结束时间
                productNameLike: '', //商品名称
                isFollow: 'all', //T是   F 否
                page:1,
                size:10
            },
            dataList: [],
            time1: '',
            totalCount: 0
		}
	},
	methods: {
		getDataList () {
            if (!!this.time1 && this.time1.length > 0) {
                this.getDataParam.geGmtQuery = this.$root.format(this.time1[0]);
                this.getDataParam.leGmtQuery = this.$root.format(this.time1[1]);
            } else {
                this.getDataParam.geGmtQuery = "";
                this.getDataParam.leGmtQuery = "";
            }
            let param = {...this.getDataParam};
            param.page = (param.page - 1);
            if (param.isFollow === 'all') {
                param.isFollow = null;
            }
            this.$http('POST', '/admin/data/page', {}, param, (status, res) => {
                if (status) {
                    if(!!res.content && res.content.length > 0) {
                        this.dataList = res.content;
                    }else {
                        this.dataList = [];
                    }
                    this.totalCount = res.totalCount;
                }
            })
        },
        searchGetDataList () {
            this.getDataParam.page = 1;
            this.getDataList();
        },
        changePageSize (val) {
            this.getDataParam.size = val;
            this.getDataParam.page = 1;
            this.getDataList();
        },
        getExport () {
            if (!!this.time1 && this.time1.length > 0) {
                this.getDataParam.geGmtQuery = this.$root.format(this.time1[0]);
                this.getDataParam.leGmtQuery = this.$root.format(this.time1[1]);
            } else {
                this.getDataParam.geGmtQuery = "";
                this.getDataParam.leGmtQuery = "";
            }
            let param = {...this.getDataParam};
            if (param.isFollow === 'all') {
                param.isFollow = null;
            }
            const loading = this.load();
            this.$http('POST', '/admin/data/export', {}, param, (status, res) => {
                loading.close();
                if (status) {
                    if (res.status === '200') {
                        this.educe(res.data);
                    }
                }
            })
        },
	},
	mounted () {
        this.getDataParam.userId = this.$route.query.id;
        this.getDataList();
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#personalRecords {width: 100%;height: calc(100vh - 132px);}
#personalRecords .content {height: calc(100% - 76px);}
#personalRecords .content .tab {height: calc(100% - 125px);}
#personalRecords >>>.el-table th.type>.cell, #personalRecords >>>.el-table td.type>.cell {margin-left: 75px;}
</style>



// WEBPACK FOOTER //
// src/views/user/personalRecords.vue